import React from 'react';
import Image from 'next/image';

/**
 * "Synchrony Wellness Pharmacy" with logo.
 */
export const SynchronyLogo = () => {
  return <Image height={179.37} src="/logos/dark.png" width={326} />;
};
